import _ from 'lodash';
// eslint-disable-next-line
import Big from 'big.js';
import { canadianFeeTaxes } from '../constants';

export const addCanadianDeliveryFeeTaxIfApplicable = (dispensary, deliveryFee, salesTaxTotal, receipt) => {
  // In Canada there is a tax applied to Delivery Fees.
  // At this time the only dispensaries that use this
  // are in Canada, are discounts first, and are cumulative.
  // We are going to punt on designing UI and input for this
  // and go with those assumptions.
  if (dispensary.location?.country === 'Canada') {
    const deliveryFeeTax = deliveryFee.times(
      canadianFeeTaxes[_.toUpper(dispensary.location.state)] || canadianFeeTaxes.default
    );
    salesTaxTotal = salesTaxTotal.plus(deliveryFeeTax);
    receipt.addTax({ type: `sales`, value: deliveryFeeTax.times(100) });
  }
  return salesTaxTotal;
};

export const calculateDeliveryFee = (deliveryOption, dispensary, subtotalMinusCredit) => {
  if (deliveryOption === 'delivery') {
    const feeType = dispensary.deliveryInfo?.feeType ?? 'flat';
    if (feeType === 'flat' && _.isFinite(dispensary.deliveryInfo?.fee) && dispensary.deliveryInfo?.fee > 0) {
      return Big(dispensary.deliveryInfo.fee / 100, 'Delivery Info Fee');
    }

    if (
      feeType === 'percent' &&
      _.isFinite(dispensary.deliveryInfo?.percentFee) &&
      dispensary.deliveryInfo?.percentFee > 0
    ) {
      return subtotalMinusCredit.times(Big(dispensary.deliveryInfo.percentFee / 100));
    }

    if (!_.isEmpty(dispensary.feeTiers)) {
      let deliveryFee = Big(0);
      _.forEach(dispensary.feeTiers, (tier) => {
        const { feeType: tierFeeType, percentFee } = tier;

        const min = _.toNumber(tier.min);
        const max = _.toNumber(tier.max);
        const fee = _.toNumber(tier.fee);

        if (subtotalMinusCredit?.gte(min) && subtotalMinusCredit?.lte(max)) {
          if (tierFeeType === 'percent' && _.isFinite(percentFee)) {
            deliveryFee = subtotalMinusCredit.times(Big(percentFee / 100));
          } else {
            deliveryFee = Big(fee, 'Fee');
          }
        }
      });
      return deliveryFee;
    }
  }
  return Big(0);
};

export const calculatePaymentFeeIfApplicable = (
  dispensary,
  paymentMethod,
  negativePosttaxSubtotal,
  altBasisForZeroedSubtotal,
  posttaxSubtotal,
  receipt
) => {
  let paymentFee = Big(0);
  const feeInfo = _.find(
    dispensary.paymentFees,
    (feeEntry) =>
      feeEntry.paymentType === paymentMethod ||
      (feeEntry.paymentType === 'creditCardAtDoor' && paymentMethod === 'creditCard') ||
      (feeEntry.paymentType === 'debitOnly' && paymentMethod === 'debitCard') ||
      (feeEntry.paymentType === 'debit' && paymentMethod === 'debitCard') ||
      (_.includes([`creditCard`, `creditCardAtDoor`, `creditCardByPhone`], feeEntry.paymentType) &&
        paymentMethod === 'inStoreCreditCard')
  );
  if (feeInfo) {
    const { fee, feeType } = feeInfo;
    if (feeType === 'cents') {
      paymentFee = Big(fee, 'Fee');
    } else {
      // Use product total instead of subtotal, if a discount has brought the subtotal to a negative
      // value and we zeroed it above.
      const subtotalForFeeCalc = negativePosttaxSubtotal ? altBasisForZeroedSubtotal : posttaxSubtotal;
      // subtotal * (fee / 100) * 100 -- last 100 because we are returning answer in cents
      paymentFee = subtotalForFeeCalc.times(fee).round();
    }
  }
  receipt.addFee({ type: `payment`, value: paymentFee });
  return paymentFee;
};
